import { API_ENDPOINT } from 'api/constants';

const isServer = typeof window === 'undefined';

class TagCacheService {
  constructor() {
    this.cache = new Map();
    this.TTL = 5 * 60 * 1000; // 5 минут время жизни кэша
    this.API_BASE_URL = isServer ? (process.env.API_BASE_URL || API_ENDPOINT) : API_ENDPOINT;

    if (isServer) {
      setInterval(() => this.cleanExpiredCache(), this.TTL);
    }
  }

  cleanExpiredCache() {
    const now = Date.now();
    for (const [key, value] of this.cache.entries()) {
      if (value.expiry <= now) {
        this.cache.delete(key);
      }
    }
  }

  async getTagData(tagName) {
    const cacheKey = `tag:${tagName}`;

    if (isServer) {
      const cached = this.cache.get(cacheKey);
      if (cached && cached.expiry > Date.now()) {

        return cached.data;
      }
      return this.updateSingleTag(tagName);
    }

    try {
      const response = await fetch(`${this.API_BASE_URL}/tags/${tagName}`);

      if (!response.ok) return null;
      return response.json();
    } catch (_error) {
      return null;
    }
  }

  async setTagData(tagName, data) {
    if (!isServer) return;

    const cacheKey = `tag:${tagName}`;
    const expiry = Date.now() + this.TTL;

    this.cache.set(cacheKey, {
      data,
      expiry
    });
  }

  async invalidateTagCache(tagName) {
    if (!isServer) return;

    const cacheKey = `tag:${tagName}`;
    this.cache.delete(cacheKey);
  }

  async updateSingleTag(tagName) {
    if (!isServer) return null;

    try {
      const response = await fetch(`${this.API_BASE_URL}/tags/${tagName}`);

      if (response.status === 404 || !response.ok) {
        return null;
      }

      const data = await response.json();
      await this.setTagData(tagName, data);

      return data;
    } catch (_error) {
      return null;
    }
  }
}

const tagCacheService = new TagCacheService();

export { tagCacheService }; 